import {SmartComponent} from "smart-component-js";

class MissionEntrypointComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.mission = this.element.dataset.mission;
        this.campaign = this.element.dataset.campaign;
        this.init();
    }

    checkMissionStatus() {
        this.element.classList.add('loading');
        let url = `/api/1.0/loyalty/campaign/${this.campaign}/mission/${this.mission}/status`;

        youserxp.ajax(url, {
            method: 'GET',
            auth: true
        }).then(
            (obj) => this.checkResult(obj.body),
            () => this.element.classList.remove('loading'));
    }

    checkResult(data) {
        this.element.classList.remove('loading');
        if (data.completionDate) {
            this.element.querySelector('.mission-entrypoint__already-completed').classList.remove('hidden');
            return;
        }

        if (data.canExecuteMission) this.element.querySelector('.mission-entrypoint__link').classList.remove('hidden');
    }


    init() {
        if (!this.mission) {
            this.element.querySelector('.mission-entrypoint__already-completed').classList.remove('hidden');
            return;
        }
        this.checkMissionStatus();
    }
}

export default MissionEntrypointComponent;
